import { render, staticRenderFns } from "./ItemLazyImg.vue?vue&type=template&id=3af1c7f0&"
import script from "./ItemLazyImg.vue?vue&type=script&lang=js&"
export * from "./ItemLazyImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JVolke\\Documents\\plentyDevTool\\38722\\18\\KrauseSohn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3af1c7f0')) {
      api.createRecord('3af1c7f0', component.options)
    } else {
      api.reload('3af1c7f0', component.options)
    }
    module.hot.accept("./ItemLazyImg.vue?vue&type=template&id=3af1c7f0&", function () {
      api.rerender('3af1c7f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/itemList/ItemLazyImg.vue"
export default component.exports